module.exports = __webpack_public_path__ + "static/media/eye-solid.54aef652.svg";